var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.92 46.079998",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e397ce440f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 19 L 35 19 L 35 29.867188 L 2 29.867188 Z M 2 19 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb814110ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.078125 8 L 13 8 L 13 29 L 1.078125 29 Z M 1.078125 8 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5e79a61d85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 7.074219 L 35 7.074219 L 35 21 L 2 21 Z M 2 7.074219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e1afc1d6b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 8 L 36.371094 8 L 36.371094 29 L 24 29 Z M 24 8 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 380553921
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 19 L 35 19 L 35 29.867188 L 2 29.867188 Z M 2 19 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "df8336634a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.078125 8 L 13 8 L 13 29 L 1.078125 29 Z M 1.078125 8 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7203d1a243"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 7.074219 L 35 7.074219 L 35 21 L 2 21 Z M 2 7.074219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6367a3b1df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 8 L 36.371094 8 L 36.371094 29 L 24 29 Z M 24 8 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e397ce440f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 34.402344 29.277344 L 23.332031 20.085938 C 23.007812 19.816406 22.539062 19.816406 22.21875 20.085938 L 19.234375 22.5625 C 18.933594 22.808594 18.5 22.808594 18.199219 22.5625 L 15.21875 20.085938 C 14.894531 19.816406 14.425781 19.816406 14.101562 20.085938 L 3.03125 29.277344 C 2.878906 29.402344 2.96875 29.652344 3.167969 29.652344 L 34.269531 29.652344 C 34.464844 29.652344 34.554688 29.402344 34.402344 29.277344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb814110ff)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 12.71875 18.011719 L 1.429688 8.636719 C 1.289062 8.523438 1.082031 8.621094 1.082031 8.796875 L 1.082031 27.957031 C 1.082031 28.132812 1.289062 28.234375 1.429688 28.117188 L 12.71875 18.746094 C 12.949219 18.554688 12.949219 18.199219 12.71875 18.011719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5e79a61d85)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 3.03125 7.476562 L 18.292969 20.152344 C 18.539062 20.355469 18.894531 20.355469 19.140625 20.152344 L 34.402344 7.476562 C 34.554688 7.351562 34.464844 7.105469 34.269531 7.105469 L 3.167969 7.105469 C 2.96875 7.105469 2.878906 7.351562 3.03125 7.476562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e1afc1d6b5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 36.003906 8.636719 L 24.714844 18.011719 C 24.484375 18.199219 24.484375 18.554688 24.714844 18.746094 L 36.003906 28.117188 C 36.144531 28.234375 36.351562 28.136719 36.351562 27.957031 L 36.351562 8.796875 C 36.351562 8.621094 36.144531 8.523438 36.003906 8.636719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0380553921)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 34.425781 29.457031 L 23.347656 20.191406 C 23.023438 19.921875 22.554688 19.921875 22.230469 20.191406 L 19.246094 22.6875 C 18.945312 22.9375 18.511719 22.9375 18.210938 22.6875 L 15.226562 20.191406 C 14.902344 19.921875 14.433594 19.921875 14.109375 20.191406 L 3.03125 29.457031 C 2.878906 29.585938 2.96875 29.835938 3.167969 29.835938 L 34.289062 29.835938 C 34.488281 29.835938 34.578125 29.585938 34.425781 29.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#df8336634a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 12.726562 18.097656 L 1.429688 8.648438 C 1.292969 8.535156 1.082031 8.632812 1.082031 8.8125 L 1.082031 28.125 C 1.082031 28.304688 1.292969 28.40625 1.429688 28.289062 L 12.726562 18.839844 C 12.957031 18.648438 12.957031 18.292969 12.726562 18.097656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7203d1a243)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 3.03125 7.480469 L 18.304688 20.257812 C 18.550781 20.460938 18.90625 20.460938 19.152344 20.257812 L 34.425781 7.480469 C 34.578125 7.355469 34.488281 7.105469 34.289062 7.105469 L 3.167969 7.105469 C 2.96875 7.105469 2.878906 7.355469 3.03125 7.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6367a3b1df)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 36.027344 8.648438 L 24.730469 18.097656 C 24.5 18.292969 24.5 18.648438 24.730469 18.839844 L 36.027344 28.289062 C 36.167969 28.40625 36.375 28.304688 36.375 28.125 L 36.375 8.8125 C 36.375 8.632812 36.167969 8.535156 36.027344 8.648438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.6a2bb1c3b37ee087d2bdfb82e655da95.svg";
export { ForwardRef as ReactComponent };